// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconExternalLink = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12 4H4v16h16v-8h-2v6H6V6h6z" />,
    <path d="M20 4h-6v2h2.586l-5.293 5.293 1.414 1.414L18 7.414V10h2z" />
  );
export default SvgIconExternalLink;
